import moment from 'moment-timezone';

/* global google */
export const validateLocation = (address, sendCompleteAddress) => {
  return new Promise((resolve, reject) => {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode(address, function (results, status) {
      if (
        status === google.maps.GeocoderStatus.OK &&
        results.length > 0 &&
        !results[0].partial_match
      ) {
        if (sendCompleteAddress) {
          resolve({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
            address: results[0]
          });
        } else {
          resolve({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          });
        }
      } else {
        resolve({
          lat: undefined,
          lng: undefined
        });
      }
    });
  });
};

/**
 *
 * @param {list} ServiceLocations "take service locations"
 * @returns {bool}
 */
export const activeLocations = ServiceLocations => {
  let activeLocationCount = 0;
  ServiceLocations.forEach(location => {
    if (location.IsActive && location.LocationType !== 'billing') {
      //don't consider billing location as it will always be active
      activeLocationCount = activeLocationCount + 1;
    }
  });
  return activeLocationCount;
};

export const getCustomerName = customerObj => {
  const { AddressType, FirstName, LastName, BusinessName, Type } = customerObj || {};
  let customerName = '';
  if (AddressType === 'commercial' || Type === 'commercial') {
    if (BusinessName) {
      customerName = BusinessName;
    } else {
      customerName = `${FirstName ? FirstName + ' ' : ''} ${LastName ? LastName : ''}`;
    }
  } else {
    if (FirstName || LastName) {
      customerName = `${FirstName ? FirstName + ' ' : ''} ${LastName ? LastName : ''}`;
    } else {
      customerName = BusinessName;
    }
  }

  return customerName;
};
/**
 *
 * @param {object} selectedCustomers
 * @param {list} customerList
 * @returns list
 */
export const getCustomerDetailsForAddButtons = (selectedCustomers = {}, customerList = []) => {
  const keys = Object.keys(selectedCustomers);
  const filteredCustomers = keys.filter(key => selectedCustomers[key]);
  if (filteredCustomers.length !== 1) {
    return [];
  }
  const filteredActiveCutomerDetails = customerList.filter(
    customer => customer.CustomerId === filteredCustomers[0] && customer.IsActive
  );
  return filteredActiveCutomerDetails;
};

export const isAddButtonDisabled = (selectedCustomers = {}, customerList = []) => {
  const keys = Object.keys(selectedCustomers);
  const filteredCustomers = keys.filter(key => selectedCustomers[key]);

  if (
    customerList.filter(
      customer => customer.CustomerId === filteredCustomers[0] && customer.IsActive
    )
  ) {
    return false;
  } else return true;
};
